import gatewayService from '../service/gateway'

const state =
{
    loading: false,
    searchResult: {
        total: 0,
        gateways: [],
    }
};

const actions = {

    getGateways({ commit }, query) {
        commit('setLoading', true)
        return gatewayService.getGateways(query).then(result => {
            commit('setSearchResult', result)
        }).finally(() =>
            commit('setLoading', false)
        )
    },
    updateStatusShadow({ commit }, shadow) {
        commit('setStatusShadow', shadow)
    },
    updateConfigShadow({ commit }, shadow) {
        commit('setConfigShadow', shadow)
    },
    // eslint-disable-next-line no-empty-pattern
    updateRequestedConfig({ }, requested) {
        return gatewayService.updateConfig(requested.id, requested)
    }

};
const mutations = {

    setLoading(state, bool) {
        state.loading = bool
    },
    setSearchResult(state, result) {
        state.searchResult = result
        state.loading = false
    },
    setStatusShadow(state, shadow) {
        let index = state.searchResult.gateways.findIndex(x => x._id == shadow.id)
        if (index != -1) {
            state.searchResult.gateways[index].status = {
                ...state.searchResult.gateways[index].status,
                shadow: shadow
            }
        }
    },
    setConfigShadow(state, shadow) {
        // console.log(shadow)
        let index = state.searchResult.gateways.findIndex(x => x._id == shadow.id)
        if (index != -1) {
            state.searchResult.gateways[index].config = {
                ...state.searchResult.gateways[index].config,
                shadow: shadow
            }
        }
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
